import {
  ActiveTaskRouteParams,
  Driver,
  HomeState,
  NextShiftData,
  ShiftCountByStore,
  ShiftData,
} from '../types';
import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {FileUploadData} from '@buncha/config/fileUpload/type';
import {Task} from '@buncha/config/onfleet/types';

const initialState: HomeState = {
  counter: 0,
  shiftData: {active: undefined, pending: []},
  nextShiftData: {upcoming: []},
  shiftCountByStore: [],
  batchShiftId: '',
  batchShiftKey: '',
  codepushLatestVersion: '',
  fileUploadData: {},
  driver: undefined,
  driverTasks: undefined,
  activeTask: undefined,
  activeTaskParams: undefined,
  forceCloseModal: false,
  meijerOrderExists: false,
  adjOOSIdsOpened: [],
  onfleetImages: [],
};

const reducer = {
  setTodayShifts: function (
    state: HomeState,
    action: PayloadAction<{data: ShiftData; isOnlyAcive?: boolean}>,
  ) {
    const payload = action.payload;
    if (payload.isOnlyAcive) {
      state.shiftData.active = payload.data.active;
    } else {
      state.shiftData.pending = payload.data.pending;
      state.shiftData.active = payload.data.active;
    }
  },
  setNextShifts: function (
    state: HomeState,
    action: PayloadAction<NextShiftData>,
  ) {
    state.nextShiftData.upcoming = action.payload.upcoming;
  },
  setShiftCountByStore: function (
    state: HomeState,
    action: PayloadAction<ShiftCountByStore[]>,
  ) {
    state.shiftCountByStore = action.payload;
  },
  setBatchShiftId: function (
    state: HomeState,
    action: PayloadAction<{batchShiftId: string; batchShiftKey: string}>,
  ) {
    state.batchShiftId = action.payload.batchShiftId;
    state.batchShiftKey = action.payload.batchShiftKey;
  },
  setCodePushLatestVersion: function (
    state: HomeState,
    action: PayloadAction<string>,
  ) {
    state.codepushLatestVersion = action.payload;
  },
  setFileUplaodData: function (
    state: HomeState,
    action: PayloadAction<FileUploadData>,
  ) {
    state.fileUploadData = action.payload;
  },
  addOnfleetImage: function (
    state: HomeState,
    action: PayloadAction<string[]>,
  ) {
    state.onfleetImages = [...state.onfleetImages, ...action.payload];
  },
  removeOnfleetImage: function (
    state: HomeState,
    action: PayloadAction<string>,
  ) {
    let images = [...state.onfleetImages];
    images = images.filter(image => image !== action.payload);
    state.onfleetImages = images;
  },
  setDriver: function (state: HomeState, action: PayloadAction<Driver>) {
    state.driver = action.payload;
  },
  setDriverTasks: function (
    state: HomeState,
    action: PayloadAction<Task[] | undefined>,
  ) {
    state.driverTasks = action.payload;
  },
  setActiveTask: function (
    state: HomeState,
    action: PayloadAction<Task | undefined>,
  ) {
    state.activeTask = action.payload;
  },
  setActiveTaskRouteParams: function (
    state: HomeState,
    action: PayloadAction<ActiveTaskRouteParams | undefined>,
  ) {
    state.activeTaskParams = action.payload;
  },
  setForceCloseModal: function (
    state: HomeState,
    action: PayloadAction<boolean>,
  ) {
    state.forceCloseModal = action.payload;
  },
  setMeijerOrderExists: function (
    state: HomeState,
    action: PayloadAction<boolean>,
  ) {
    state.meijerOrderExists = action.payload;
  },
  setAdjOOSIdsOpened: function (
    state: HomeState,
    action: PayloadAction<number>,
  ) {
    const ids = new Set(state.adjOOSIdsOpened);
    ids.add(action.payload);
    state.adjOOSIdsOpened = Array.from(ids);
  },
};

function initSlice() {
  const slice = createSlice({
    name: 'HomeState',
    initialState,
    reducers: reducer,
  });
  return slice;
}

export default initSlice();
